import * as fromDatatype from '../datatype-library/index';

export interface app_cal_activity_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  venue: fromDatatype.VarcharDatatypeInterface;
  address_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  all_day: boolean;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  repeat: fromDatatype.VarcharDatatypeInterface;
  nth_day: fromDatatype.VarcharDatatypeInterface;
  event_group: fromDatatype.IntegerDatatypeInterface;   //data type is long
  user_create: fromDatatype.VarcharDatatypeInterface;
  user_modify: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class app_cal_activity_hdr_RowClass implements app_cal_activity_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  venue: fromDatatype.VarcharDatatypeInterface;
  address_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.TextDatatypeInterface;
  all_day: boolean;
  start_time: fromDatatype.TimestampTzDatatypeInterface;
  end_time: fromDatatype.TimestampTzDatatypeInterface;
  repeat: fromDatatype.VarcharDatatypeInterface;
  nth_day: fromDatatype.VarcharDatatypeInterface;
  event_group: fromDatatype.IntegerDatatypeInterface;   //data type is long
  user_create: fromDatatype.VarcharDatatypeInterface;
  user_modify: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}


